import { Box, Button, FileInput, Input, LoadingOverlay, Paper, Select, SimpleGrid, Space, Text, TextInput, Title } from '@mantine/core'
import React, { memo, useEffect, useState } from 'react'
import useFetch from '../../../../Customhooks/useFetch';
import { useNavigate, useParams } from 'react-router-dom';
import { baseUrl } from '../../../../Constants/constant';
import { notifications } from '@mantine/notifications';
import classes from '../ManageTransport.module.css';



const AddTransport = () => {
    const navigate = useNavigate();
    const [transportId, settransportId] = useState<any>()
    const [transporttype, setTransportType] = useState<string>('');
    const [cotwo, setCoTwo] = useState<string>('');
    const [sourceName, setSourceName] = useState<string>('');
    const [errors, setErrors] = useState<Record<string, string>>({});
    const token = localStorage.getItem("token")
    const data = [
        { value: '1', label: 'Land' },
        { value: '2', label: 'Air' },
        { value: '3', label: 'Sea' },
    ];
    const { id } = useParams();
    const method = id ? 'PUT' : 'POST'
    const url = id ? `${baseUrl}admin/transports/update/${id}` : `${baseUrl}admin/transports/add`
    const {
        data: getData,
        loading: detailLoading,
        error: getError,
        fetchData: postmaterial,
    } = useFetch({
        method: method,
        headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "token": token
        },
        body: JSON.stringify({
            transport_name: transporttype,
            co2_embodiment: cotwo,
            source_name: sourceName,
            transport_type: transportId,
        }),
    });
    const {
        data: getfieldData,
        loading: getfieldLoading,
        error: getfielderror,
        fetchData: getfield,
    } = useFetch({
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "token": token
        },
    });
    useEffect(() => {
        if (id) {
            getfield(`${baseUrl}admin/transports/${id}`)
        }
    }, [])
    useEffect(() => {
        const rowData = getfieldData?.data?.rows?.[0];
        if (rowData) {
            setTransportType(rowData.transport_name);
            setCoTwo(rowData.co2_embodiment);
            setSourceName(rowData.source_name);

            // Safely handle transportId with nullish coalescing operator
            settransportId(rowData.transport_type != null ? String(rowData.transport_type) : '');
        }
    }, [getfieldData]);

    // **Reusable function to handle input change and remove errors**
    const handleChange = (field: string, value: string | null) => {
        if (field === "tansport_type") {
            setTransportType(value as string);
        }
        else if (field === "co2_id") {
            setCoTwo(value as string);
        }
        else if (field === "source_name") {
            setSourceName(value as string);
        }
        else if (field === "transport_way") {
            settransportId(value);
        }

        // Remove the error for the field if it's being updated
        setErrors((prev: any) => ({ ...prev, [field]: undefined }));
    };

    // **Validate inputs before submitting**
    const validateFields = () => {
        let newErrors: Record<string, string> = {};

        if (!transporttype.trim()) {
            newErrors.tansport_type = "Transport Type is Required";
        }
        if (!cotwo) {
            newErrors.co2_id = "CO₂ is Required";
        }
        if (!sourceName) {
            newErrors.source_name = "Source Name is Required";
        }
        if (!transportId) {
            newErrors.transport_way = "Transport Route is Required";
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return false; // Validation failed
        }
        return true; // Validation passed
    };

    const handlesave = async () => {
        if (!validateFields()) return
        await postmaterial(url);
    };

    // UseEffect to show notification when getData or getError changes
    useEffect(() => {
        const showNotification = (type: any, title = "An error occurred") => {
            notifications.show({
                title,
                message: type === 'success'
                    ? "Transport data saved successfully."
                    : "Something went wrong. Please try again.",
                color: type === 'success' ? "green" : "red",
                classNames: classes,
            });
        };

        if (getData?.errors || getError) {
            showNotification('error', getData?.message || getError?.message);
            return;
        }

        if (getData && !getData?.errors) {
            navigate('/transport');
        }
    }, [getData, getError, navigate, classes]);



    return (
        <>
            <LoadingOverlay
                visible={getfieldLoading}
                zIndex={1000}
                overlayProps={{
                    radius: 'sm',
                    blur: 2,
                    style: {
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%'
                    }
                }}
                loaderProps={{ color: '#404040', type: 'bars' }}
            />
            <Paper shadow="xs" p="xs" radius="md">
                <Box ml={5}>
                    <Title order={4}>Add Transport</Title>
                    <Space h="lg" />
                    <Text>Transport Details</Text>
                    <Space h="xs" />
                    <SimpleGrid cols={4}>
                        <TextInput
                            variant='filled'
                            label="Transportation Type"
                            withAsterisk
                            value={transporttype}
                            onChange={(e) => handleChange("tansport_type", e.target.value)}
                            placeholder="Transportation Type"
                            radius={6}
                            error={errors.tansport_type}
                        />

                        <TextInput
                            variant='filled'
                            withAsterisk
                            label="Per/KM CO₂ E"
                            value={cotwo}
                            onChange={(e) => handleChange("co2_id", e.target.value)}
                            placeholder="Enter Embodied"
                            radius={6}
                            error={errors.co2_id}
                        />
                        <Select
                            label="Select Transport Route"
                            variant='filled'
                            data={data}
                            value={transportId}
                            withAsterisk
                            onChange={(val) => handleChange("transport_way", val)}
                            placeholder="Select Transport Route"
                            error={errors.transport_way}
                        />
                        <TextInput
                            variant='filled'
                            withAsterisk
                            label="Source"
                            value={sourceName}
                            onChange={(e) => handleChange("source_name", e.target.value)}
                            placeholder="Enter Source Name"
                            radius={6}
                            error={errors.source_name}
                        />

                    </SimpleGrid>
                    <Space h="xl" />
                    <SimpleGrid cols={6}>
                        <Button
                            variant="default"
                            radius={6}
                            onClick={() => navigate('/transport')}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="gradient"
                            gradient={{ from: '#404040', to: '#404040', deg: 90 }}
                            radius={6}
                            onClick={handlesave}
                        >
                            {id ? 'Update' : 'Save'}
                        </Button>
                    </SimpleGrid>
                </Box>
            </Paper>
        </>
    )
}

export default memo(AddTransport)